module.exports = __webpack_public_path__ + "quanthum.9757bef6f9fd3ab5d5cd.svg";


//////////////////
// WEBPACK FOOTER
// /var/www/borneo/prod/borneo_app/src/assets/vcg/css/fonts/quanthum/quanthum.svg?8kbwol
// module id = ../../../../../src/assets/vcg/css/fonts/quanthum/quanthum.svg?8kbwol
// module chunks = styles